const ADULT_AGE = 18;
const FAMILY_LIMIT = 6;
const CALLING_CODES = "1 7 20 27 30 31 32 33 34 36 39 40 41 43 44 45 46 47 48 49 51 52 53 54 55 56 57 58 60 61 62 63 64 65 66 81 82 84 86 90 91 92 93 94 95 98 211 212 213 216 218 220 221 222 223 224 225 226 227 228 229 230 231 232 233 234 235 236 237 238 239 240 241 242 243 244 245 246 247 248 249 250 251 252 253 254 255 256 257 258 260 261 262 263 264 265 266 267 268 269 290 291 297 298 299 350 351 352 353 354 355 356 357 358 359 370 371 372 373 374 375 376 377 378 379 380 381 382 383 385 386 387 389 420 421 423 500 501 502 503 504 505 506 507 508 509 590 591 592 593 594 595 596 597 598 599 670 672 673 674 675 676 677 678 679 680 681 682 683 685 686 687 688 689 690 691 692 850 852 853 855 856 880 886 960 961 962 963 964 965 966 967 968 970 971 972 973 974 975 976 977 992 993 994 995 996 998".split(" ").sort((a, b) => b.length - a.length);

function phoneDigits(value) {
  return value.replace(/\D/g, "");
}

function formatNanp(national) {
  const digits = national.slice(0, 10);
  let formatted = "+1";
  if (!digits) return formatted;
  formatted += ` (${digits.slice(0, 3)}`;
  if (digits.length < 3) return formatted;
  formatted += ")";
  if (digits.length === 3) return formatted;
  formatted += ` ${digits.slice(3, 6)}`;
  if (digits.length <= 6) return formatted;
  return `${formatted}-${digits.slice(6)}`;
}

function formatInternational(code, national) {
  const groups = [];
  let rest = national;
  while (rest.length > 4) {
    groups.push(rest.slice(0, 3));
    rest = rest.slice(3);
  }
  if (rest) groups.push(rest);
  return `+${code}${groups.length ? ` ${groups.join(" ")}` : ""}`;
}

function splitCallingCode(digits) {
  const code = CALLING_CODES.find((callingCode) => digits.startsWith(callingCode));
  const longerOpen = CALLING_CODES.some((callingCode) => callingCode.startsWith(digits) && callingCode.length > digits.length);
  if (!code || (longerOpen && digits.length === code.length)) return { code: digits, national: "" };
  return { code, national: digits.slice(code.length) };
}

function formatPhone(raw) {
  const compact = raw.replace(/[^\d+]/g, "");
  let international = compact.startsWith("+");
  let digits = phoneDigits(compact);
  if (digits.startsWith("011")) {
    international = true;
    digits = digits.slice(3);
  } else if (digits.startsWith("00")) {
    international = true;
    digits = digits.slice(2);
  }
  if (!digits) return international ? "+" : "";

  digits = digits.slice(0, 15);
  if (!international) {
    const national = digits.startsWith("1") && digits.length > 10 ? digits.slice(1, 11) : digits.slice(0, 10);
    return formatNanp(national);
  }

  const parts = splitCallingCode(digits);
  if (parts.code === "1") return formatNanp(parts.national);
  return formatInternational(parts.code, parts.national);
}

function caretAfterDigits(formatted, digitCount) {
  if (digitCount <= 0) return formatted.startsWith("+") ? 1 : 0;
  let seen = 0;
  for (let index = 0; index < formatted.length; index += 1) {
    if (/\d/.test(formatted[index])) {
      seen += 1;
      if (seen === digitCount) return index + 1;
    }
  }
  return formatted.length;
}

class MembershipEnrollment extends HTMLElement {
  connectedCallback() {
    this.productForm = document.querySelector('form[is="product-form"]');
    this.modal = this.querySelector("x-modal");
    this.config = JSON.parse(this.querySelector("[data-membership-config]").textContent);
    this.members = [];
    this.editingIndex = null;
    this.submitting = false;
    this.abortController = new AbortController();

    this.openButton = this.querySelector("[data-membership-open]");
    this.joinButton = this.modal.querySelector("[data-membership-join]");
    this.addButton = this.modal.querySelector("[data-add-member]");
    this.formView = this.modal.querySelector("[data-enrollment-form]");
    this.reviewView = this.modal.querySelector("[data-enrollment-review]");
    this.reviewSummary = this.modal.querySelector("[data-review-summary]");
    this.backButton = this.modal.querySelector("[data-review-back]");
    this.confirmButton = this.modal.querySelector("[data-review-confirm]");
    this.memberFields = this.modal.querySelector("[data-member-fields]");
    this.memberHeading = this.modal.querySelector("[data-member-heading]");
    this.memberList = this.modal.querySelector("[data-member-list]");
    this.individualLimit = this.modal.querySelector("[data-individual-limit]");
    this.familyLimit = this.modal.querySelector("[data-family-limit]");
    this.adultNote = this.modal.querySelector("[data-adult-note]");
    this.forMeGroup = this.modal.querySelector("[data-for-me-group]");
    this.forMeInputs = [...this.forMeGroup.querySelectorAll('input[name="membership_for_me"]')];
    this.selfHint = this.modal.querySelector("[data-self-hint]");
    this.otherNote = this.modal.querySelector("[data-other-note]");
    this.contact = this.modal.querySelector("[data-contact]");
    this.contactNote = this.modal.querySelector("[data-contact-note]");
    this.ownEmailWarning = this.modal.querySelector("[data-own-email-warning]");
    this.errorMessage = this.modal.querySelector("[data-membership-error]");
    this.addedView = this.modal.querySelector("[data-enrollment-added]");
    this.addedMessage = this.modal.querySelector("[data-added-message]");
    this.addAnotherButton = this.modal.querySelector("[data-add-another]");
    this.clan = this.modal.querySelector('select[name="clan"]');
    this.fields = {
      first: this.modal.querySelector('input[name="member_first"]'),
      middle: this.modal.querySelector('input[name="member_middle"]'),
      last: this.modal.querySelector('input[name="member_last"]'),
      dob: this.modal.querySelector('input[name="member_dob"]'),
      email: this.modal.querySelector('input[name="member_email"]'),
      phone: this.modal.querySelector('input[name="member_phone"]')
    };

    this.fields.dob.max = this.todayIso();
    this.fields.dob.min = "1900-01-01";
    this.phoneValue = "";
    this.defaultLabels = {
      email: this.fieldLabel(this.fields.email).textContent,
      phone: this.fieldLabel(this.fields.phone).textContent
    };

    this.addEventListener("click", (event) => {
      const optionButton = event.target.closest("[data-option-value]");
      if (optionButton && this.contains(optionButton)) {
        this.onVariantClick(optionButton);
      }
    });

    this.addButton.addEventListener("click", () => this.onAdd());
    this.joinButton.addEventListener("click", () => this.onJoin());
    this.backButton.addEventListener("click", () => this.showForm());
    this.confirmButton.addEventListener("click", () => this.onConfirm());
    this.addAnotherButton.addEventListener("click", () => this.startNew());
    this.fields.dob.addEventListener("change", () => this.applyMode());
    this.fields.phone.addEventListener("input", () => this.onPhoneInput());
    this.fields.email.addEventListener("input", () => this.updateOwnEmailWarning());
    this.forMeInputs.forEach((input) => {
      input.addEventListener("change", () => this.onForMeChange());
    });

    Object.values(this.fields).forEach((field) => {
      field.addEventListener("input", () => field.setCustomValidity(""));
    });
    this.clan.addEventListener("change", () => this.clan.setCustomValidity(""));

    const signal = this.abortController.signal;
    this.productForm?.addEventListener("variant:change", (event) => {
      this.onVariantChange(event.detail.variant);
    }, { signal });
    this.modal.addEventListener("dialog:after-show", () => this.focusFirstField(), { signal });
    this.modal.addEventListener("dialog:after-hide", () => {
      if (this.addedView.hidden) {
        this.showForm();
      } else {
        this.startNew();
      }
    }, { signal });

    this.updateActions();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  get selectedRecord() {
    const id = this.productForm?.querySelector('[name="id"]')?.value;
    return this.config.variants.find((variant) => String(variant.id) === String(id)) || this.config.variants[0];
  }

  get isFamily() {
    return Boolean(this.selectedRecord?.family);
  }

  get maxMembers() {
    return this.isFamily ? FAMILY_LIMIT : 1;
  }

  get forMe() {
    if (this.isFamily) return "";
    return this.forMeInputs.find((input) => input.checked)?.value || "";
  }

  get mode() {
    if (this.isFamily) return "family";
    if (this.forMe === "Yes") return "self";
    if (this.forMe === "No") return "other";
    return "";
  }

  get contactHidden() {
    return this.mode === "other" && !this.isAdult(this.fields.dob.value);
  }

  onForMeChange() {
    this.forMeInputs.forEach((input) => input.setCustomValidity(""));
    const customer = this.config.customer;
    if (customer) {
      const prefill = [
        [this.fields.first, customer.firstName || ""],
        [this.fields.last, customer.lastName || ""],
        [this.fields.email, customer.email || ""],
        [this.fields.phone, customer.phone ? formatPhone(customer.phone) : ""]
      ];
      prefill.forEach(([field, value]) => {
        if (!value) return;
        if (this.forMe === "Yes" && !field.value.trim()) field.value = value;
        if (this.forMe === "No" && this.sameContact(field, field.value, value)) field.value = "";
      });
      this.phoneValue = this.fields.phone.value;
    }
    this.updateActions();
  }

  sameContact(field, a, b) {
    if (field === this.fields.phone) return Boolean(phoneDigits(a)) && phoneDigits(a) === phoneDigits(b);
    return a.trim().toLowerCase() === b.trim().toLowerCase();
  }

  applyMode() {
    const mode = this.mode;
    const adult = this.isAdult(this.fields.dob.value);
    const optionalContact = mode === "self" || mode === "other";

    this.forMeGroup.hidden = this.isFamily;
    this.forMeInputs.forEach((input) => {
      input.required = !this.isFamily;
    });
    this.selfHint.hidden = mode !== "self";
    this.otherNote.hidden = mode !== "other";
    this.fields.first.required = mode !== "self";
    this.fields.last.required = mode !== "self";

    this.contact.hidden = this.contactHidden;
    if (this.contact.hidden) {
      this.fields.email.value = "";
      this.fields.phone.value = "";
      this.phoneValue = "";
    }
    this.setFieldLabel(this.fields.email, optionalContact ? this.config.emailOptional : this.defaultLabels.email);
    this.setFieldLabel(this.fields.phone, optionalContact ? this.config.phoneOptional : this.defaultLabels.phone);

    const contactRequired = mode === "family" && adult;
    this.fields.email.required = contactRequired;
    this.fields.phone.required = contactRequired;
    if (!contactRequired) {
      this.fields.email.setCustomValidity("");
      this.fields.phone.setCustomValidity("");
    }
    this.adultNote.hidden = !contactRequired;
    this.contactNote.hidden = mode !== "other" || this.contact.hidden;
    this.updateOwnEmailWarning();
  }

  updateOwnEmailWarning() {
    const ownEmail = this.config.customer?.email || "";
    const email = this.fields.email.value;
    this.ownEmailWarning.hidden = !(this.mode === "other" && ownEmail && email && this.sameContact(this.fields.email, email, ownEmail));
  }

  fieldLabel(field) {
    return field.closest(".form-control").querySelector("label");
  }

  setFieldLabel(field, text) {
    field.placeholder = text;
    this.fieldLabel(field).textContent = text;
  }

  focusFirstField() {
    if (!window.matchMedia("(hover: hover)").matches || this.formView.hidden) return;
    const target = this.isFamily
      ? this.clan
      : this.forMeInputs.find((input) => input.checked) || this.forMeInputs[0];
    target?.focus();
  }

  onVariantClick(button) {
    if (!this.productForm) return;
    const group = button.closest("[data-option-position]");
    const position = group.dataset.optionPosition;
    const value = button.dataset.optionValue;
    const formId = CSS.escape(this.productForm.getAttribute("id"));
    const radio = document.querySelector(`input[type="radio"][name="option${position}"][form="${formId}"][value="${CSS.escape(value)}"]`);

    group.querySelectorAll("[data-option-value]").forEach((option) => {
      const selected = option === button;
      option.classList.toggle("is-selected", selected);
      option.setAttribute("aria-pressed", selected ? "true" : "false");
    });

    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      const hidden = document.querySelector(`input[type="hidden"][name="option${position}"][form="${formId}"]`);
      if (hidden) {
        hidden.value = value;
        hidden.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    this.syncVariantId();
    this.updateActions();
  }

  syncVariantId() {
    const options = [...this.querySelectorAll("[data-option-position]")].map((group) => {
      return group.querySelector('[aria-pressed="true"]')?.dataset.optionValue;
    });
    const match = this.config.variants.find((variant) => {
      return variant.options.every((option, index) => option === options[index]);
    });
    const idInput = this.productForm.querySelector('[name="id"]');
    if (!match || !idInput || String(idInput.value) === String(match.id)) return;
    idInput.disabled = false;
    idInput.value = String(match.id);
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  onVariantChange(variant) {
    if (!variant) return;

    this.querySelectorAll("[data-option-position]").forEach((group) => {
      const value = variant.options[Number(group.dataset.optionPosition) - 1];
      group.querySelectorAll("[data-option-value]").forEach((option) => {
        const selected = option.dataset.optionValue === value;
        option.classList.toggle("is-selected", selected);
        option.setAttribute("aria-pressed", selected ? "true" : "false");
      });
    });

    if (!this.isFamily && this.members.length === 1) {
      if (this.editingIndex !== 0) this.loadMember(this.members[0]);
      this.members = [];
      this.editingIndex = null;
      this.renderList();
    }

    this.updateActions();
  }

  onAdd() {
    if (!this.requireClan()) return;
    if (this.isBlank(this.readMember())) {
      this.fail(this.fields.first, this.config.memberRequired);
      return;
    }
    if (!this.validateMember()) return;
    if (this.editingIndex == null && this.members.length >= this.maxMembers) return;
    this.storeCurrentMember();
  }

  onJoin() {
    if (!this.productForm || this.submitting || this.joinButton.disabled) return;
    if (!this.requireForMe()) return;
    if (!this.requireClan()) return;
    if (!this.isFamily && this.members.length > 1) {
      this.individualLimit.hidden = false;
      return;
    }

    const current = this.readMember();
    if (!this.isBlank(current) || (!this.isFamily && this.members.length === 0)) {
      if (!this.validateMember()) return;
      if (this.editingIndex == null && this.members.length >= this.maxMembers) {
        this.familyLimit.hidden = false;
        return;
      }
      this.storeCurrentMember();
    }

    if (this.members.length === 0) {
      this.fail(this.fields.first, this.config.memberRequired);
      return;
    }

    if (!this.isFamily && this.members.length !== 1) {
      this.individualLimit.hidden = false;
      return;
    }

    this.showReview();
  }

  showReview() {
    this.renderReview();
    this.errorMessage.hidden = true;
    this.formView.hidden = true;
    this.reviewView.hidden = false;
    this.confirmButton.focus();
  }

  showForm() {
    this.reviewView.hidden = true;
    this.addedView.hidden = true;
    this.formView.hidden = false;
    this.submitting = false;
    this.confirmButton.removeAttribute("aria-busy");
    this.joinButton.removeAttribute("aria-busy");

    if (!this.isFamily && this.members.length === 1) {
      this.loadMember(this.members[0]);
      this.members = [];
      this.editingIndex = null;
      this.renderList();
    }
  }

  showAdded(names) {
    this.addedMessage.textContent = this.mode === "self" || !names
      ? this.config.addedSelf
      : this.config.addedOther.replaceAll("__NAME__", names);
    this.formView.hidden = true;
    this.reviewView.hidden = true;
    this.addedView.hidden = false;
    this.addedMessage.focus();
  }

  startNew() {
    this.members = [];
    this.editingIndex = null;
    this.clearMemberForm();
    this.clan.value = "";
    this.clan.setCustomValidity("");
    this.forMeInputs.forEach((input) => {
      input.checked = false;
      input.setCustomValidity("");
    });
    this.showForm();
    this.renderList();
    this.focusFirstField();
  }

  renderReview() {
    const summary = document.createElement("div");
    summary.className = "v-stack gap-4";

    const record = this.selectedRecord;
    const planName = record?.options?.filter(Boolean).join(" · ") || "";
    const plan = document.createElement("p");
    plan.className = "membership-review__plan";
    plan.textContent = record?.price ? `${planName} · ${record.price}/yr` : planName;
    summary.append(plan);

    if (!this.isFamily) {
      const forMe = document.createElement("p");
      forMe.className = "membership-review__detail";
      forMe.textContent = this.forMe === "Yes" ? this.config.forMeYes : this.config.forMeNo;
      summary.append(forMe);
    }

    const clan = document.createElement("p");
    clan.className = "membership-review__detail";
    const clanLabel = document.createElement("span");
    clanLabel.className = "text-subdued";
    clanLabel.textContent = `${this.config.clanLabel}: `;
    clan.append(clanLabel, document.createTextNode(this.clan.value));
    summary.append(clan);

    const list = document.createElement("ul");
    list.className = "membership-enrollment__members v-stack";
    this.members.forEach((member, index) => {
      if (index > 0) list.append(document.createElement("hr"));
      const item = document.createElement("li");
      item.className = "membership-member v-stack";
      const name = document.createElement("span");
      name.textContent = this.displayName(member) || this.config.selfName;
      item.append(name);
      this.appendReviewDetail(item, this.config.dobLabel, this.formatDob(member.dob));
      if (member.email) this.appendReviewDetail(item, this.config.emailLabel, member.email);
      if (member.phone) this.appendReviewDetail(item, this.config.phoneLabel, member.phone);
      list.append(item);
    });
    summary.append(list);
    this.reviewSummary.replaceChildren(summary);
  }

  appendReviewDetail(parent, label, value) {
    const line = document.createElement("p");
    line.className = "membership-review__detail text-sm";
    const name = document.createElement("span");
    name.className = "text-subdued";
    name.textContent = `${label}: `;
    line.append(name, document.createTextNode(value));
    parent.append(line);
  }

  async onConfirm() {
    if (!this.productForm || this.submitting || this.confirmButton.disabled) return;

    this.writeProperties();
    if (!this.productForm.reportValidity()) {
      this.clearProperties();
      return;
    }

    this.attachSellingPlan();
    this.submitting = true;
    this.errorMessage.hidden = true;
    this.confirmButton.setAttribute("aria-busy", "true");

    const formData = new FormData(this.productForm);
    formData.set("quantity", "1");
    const names = formData.get("properties[Members]") || "";
    this.clearProperties();

    try {
      const added = await this.addToCart(formData);
      if (added) this.showAdded(names);
    } catch {
      this.showError(this.config.addError);
    } finally {
      this.submitting = false;
      this.confirmButton.removeAttribute("aria-busy");
    }
  }

  async addToCart(formData) {
    const root = window.Shopify?.routes?.root || "/";
    const properties = this.lineProperties(formData);
    const variantId = String(formData.get("id"));

    const existing = await (await fetch(`${root}cart.js`)).json();
    const duplicate = existing.items.some((item) => {
      return String(item.variant_id) === variantId && this.sameProperties(item.properties, properties);
    });
    if (duplicate) {
      this.showError(this.config.alreadyInCart);
      return false;
    }

    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } }));
    formData.set("sections", sections.join(","));
    formData.set("sections_url", `${root}variants/${variantId}`);

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    try {
      const response = await fetch(`${root}cart/add.js`, {
        body: formData,
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      const json = await response.json();
      if (!response.ok) {
        this.showError(json.description || this.config.addError);
        return false;
      }

      const cart = await (await fetch(`${root}cart.js`)).json();
      cart.sections = json.sections;
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "membership:add", cart }
      }));
      return true;
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }

  lineProperties(formData) {
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === "string" && value !== "") properties[match[1]] = value;
    }
    return properties;
  }

  sameProperties(cartProperties, properties) {
    const normalize = (object) => JSON.stringify(
      Object.entries(object || {})
        .filter(([, value]) => value !== "" && value != null)
        .map(([key, value]) => [key, String(value)])
        .sort(([a], [b]) => a.localeCompare(b))
    );
    return normalize(cartProperties) === normalize(properties);
  }

  showError(message) {
    this.errorMessage.textContent = message;
    this.errorMessage.hidden = false;
  }

  requireForMe() {
    if (this.isFamily || this.forMe) return true;
    this.fail(this.forMeInputs[0], this.config.forMeRequired);
    return false;
  }

  requireClan() {
    if (this.clan.value) {
      this.clan.setCustomValidity("");
      return true;
    }
    this.fail(this.clan, this.config.clanRequired);
    return false;
  }

  storeCurrentMember() {
    const member = this.readMember();
    if (this.editingIndex == null) {
      this.members.push(member);
    } else {
      this.members[this.editingIndex] = member;
      this.editingIndex = null;
    }
    this.clearMemberForm();
    this.renderList();
  }

  onEdit(index) {
    this.editingIndex = index;
    this.loadMember(this.members[index]);
    this.memberFields.hidden = false;
    this.updateActions();
    this.fields.first.focus();
  }

  onRemove(index) {
    if (this.editingIndex === index) {
      this.editingIndex = null;
      this.clearMemberForm();
    } else if (this.editingIndex != null && this.editingIndex > index) {
      this.editingIndex -= 1;
    }

    this.members.splice(index, 1);

    if (!this.isFamily && this.members.length === 1) {
      this.loadMember(this.members[0]);
      this.members = [];
      this.editingIndex = null;
    }

    this.renderList();
  }

  renderList() {
    this.memberList.replaceChildren();

    this.members.forEach((member, index) => {
      if (index > 0) this.memberList.append(document.createElement("hr"));

      const item = document.createElement("li");
      item.className = "membership-member h-stack justify-between gap-4";

      const text = document.createElement("div");
      text.className = "v-stack";
      const name = document.createElement("span");
      name.textContent = this.displayName(member) || this.config.selfName;
      const dob = document.createElement("span");
      dob.className = "text-xs text-subdued";
      dob.textContent = this.formatDob(member.dob);
      text.append(name, dob);

      const actions = document.createElement("div");
      actions.className = "h-stack gap-3";

      const edit = document.createElement("button");
      edit.type = "button";
      edit.className = "link text-xs";
      edit.textContent = this.config.edit;
      edit.addEventListener("click", () => this.onEdit(index));

      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "link text-xs";
      remove.textContent = this.config.remove;
      remove.addEventListener("click", () => this.onRemove(index));

      if (this.isFamily || this.members.length <= 1) actions.append(edit);
      actions.append(remove);
      item.append(text, actions);
      this.memberList.append(item);
    });

    this.updateActions();
  }

  updateActions() {
    const count = this.members.length;
    const overIndividual = !this.isFamily && count > 1;
    const atCapacity = this.isFamily && count >= FAMILY_LIMIT && this.editingIndex == null;
    const available = Boolean(this.selectedRecord?.available);
    const record = this.selectedRecord;
    const label = this.config.join.replaceAll("__PRICE__", record?.price || "");

    this.individualLimit.hidden = !overIndividual;
    this.familyLimit.hidden = !atCapacity;
    this.memberFields.hidden = (this.editingIndex == null && (overIndividual || atCapacity)) || !this.mode;
    this.addButton.hidden = !this.isFamily || this.memberFields.hidden;
    this.addButton.textContent = this.editingIndex == null ? this.config.addMember : this.config.saveMember;
    this.applyMode();
    this.updateMemberHeading();
    this.joinButton.classList.toggle("button--outline", this.isFamily);
    this.openButton.disabled = !available;
    this.joinButton.disabled = !available || overIndividual;

    const labels = new Set([
      ...this.querySelectorAll("[data-membership-join-label]"),
      ...this.modal.querySelectorAll("[data-membership-join-label]")
    ]);
    labels.forEach((node) => {
      node.textContent = label;
    });
  }

  updateMemberHeading() {
    if (!this.isFamily) {
      this.memberHeading.hidden = this.memberFields.hidden;
      this.memberHeading.textContent = this.mode === "other" ? this.config.theirDetails : this.config.yourDetails;
      return;
    }
    const number = (this.editingIndex == null ? this.members.length : this.editingIndex) + 1;
    this.memberHeading.hidden = !this.isFamily || this.memberFields.hidden;
    this.memberHeading.textContent = number === 1
      ? this.config.yourDetails
      : this.config.memberDetails.replaceAll("__NUMBER__", String(number));
  }

  readMember() {
    const contactHidden = this.contactHidden;
    return {
      first: this.fields.first.value.trim(),
      middle: this.fields.middle.value.trim(),
      last: this.fields.last.value.trim(),
      dob: this.fields.dob.value,
      email: contactHidden ? "" : this.fields.email.value.trim(),
      phone: contactHidden ? "" : this.fields.phone.value.trim()
    };
  }

  loadMember(member) {
    this.fields.first.value = member.first;
    this.fields.middle.value = member.middle;
    this.fields.last.value = member.last;
    this.fields.dob.value = member.dob;
    this.fields.email.value = member.email;
    this.fields.phone.value = member.phone ? formatPhone(member.phone) : "";
    this.phoneValue = this.fields.phone.value;
    this.applyMode();
  }

  clearMemberForm() {
    Object.values(this.fields).forEach((field) => {
      field.value = "";
      field.setCustomValidity("");
    });
    this.phoneValue = "";
    this.applyMode();
  }

  onPhoneInput() {
    const input = this.fields.phone;
    const start = input.selectionStart ?? input.value.length;
    const previous = this.phoneValue || "";
    let raw = input.value;
    let digitCount = phoneDigits(raw.slice(0, start)).length;

    if (raw.length < previous.length) {
      const deleted = previous.slice(start, start + (previous.length - raw.length));
      if (deleted && !/\d/.test(deleted)) {
        const digits = phoneDigits(raw);
        const dropIndex = Math.max(0, digitCount - 1);
        const next = digits.slice(0, dropIndex) + digits.slice(dropIndex + 1);
        raw = `${previous.startsWith("+") || raw.includes("+") ? "+" : ""}${next}`;
        digitCount = dropIndex;
      }
    }

    const originalLength = input.value.length;
    const atEnd = start >= originalLength;
    const formatted = formatPhone(raw);
    this.phoneValue = formatted;
    input.value = formatted;
    const caret = atEnd ? formatted.length : caretAfterDigits(formatted, digitCount);
    input.setSelectionRange(caret, caret);
  }

  isBlank(member) {
    return !member.first && !member.middle && !member.last && !member.dob && !member.email && !member.phone;
  }

  contactTaken(field, value) {
    return this.members.some((existing, index) => {
      if (index === this.editingIndex) return false;
      if (field === "email") return existing.email.trim().toLowerCase() === value;
      return phoneDigits(existing.phone) === value;
    });
  }

  validateMember() {
    const member = this.readMember();
    const nameRequired = this.mode !== "self";
    const contactRequired = this.mode === "family" && this.isAdult(member.dob);

    if (nameRequired && !member.first) {
      this.fail(this.fields.first, this.config.firstRequired);
      return false;
    }
    this.fields.first.setCustomValidity("");

    if (nameRequired && !member.last) {
      this.fail(this.fields.last, this.config.lastRequired);
      return false;
    }
    this.fields.last.setCustomValidity("");

    if (!member.dob) {
      this.fail(this.fields.dob, this.config.dobRequired);
      return false;
    }
    if (member.dob > this.todayIso()) {
      this.fail(this.fields.dob, this.config.dobFuture);
      return false;
    }
    this.fields.dob.setCustomValidity("");
    this.applyMode();

    if (contactRequired && !member.email) {
      this.fail(this.fields.email, this.config.emailRequired);
      return false;
    }
    if (member.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(member.email)) {
      this.fail(this.fields.email, this.config.emailInvalid);
      return false;
    }
    if (member.email && this.contactTaken("email", member.email.toLowerCase())) {
      this.fail(this.fields.email, this.config.emailDuplicate);
      return false;
    }
    this.fields.email.setCustomValidity("");

    const digits = phoneDigits(member.phone);
    const national = digits.startsWith("1") ? digits.slice(1) : digits;
    const invalidNanp = digits.startsWith("1") && national.length !== 10;
    const invalidInternational = !digits.startsWith("1") && (digits.length < 8 || digits.length > 15);
    if (contactRequired && !member.phone) {
      this.fail(this.fields.phone, this.config.phoneRequired);
      return false;
    }
    if (member.phone && (invalidNanp || invalidInternational)) {
      this.fail(this.fields.phone, this.config.phoneInvalid);
      return false;
    }
    if (digits && this.contactTaken("phone", digits)) {
      this.fail(this.fields.phone, this.config.phoneDuplicate);
      return false;
    }
    this.fields.phone.setCustomValidity("");

    return true;
  }

  attachSellingPlan() {
    const planId = document.querySelector('select[name="subs_interval"]')?.value
      || document.querySelector('input[name="selling_plan"]')?.value;
    const planInput = document.querySelector('input[name="selling_plan"]');
    if (!planInput || !planId) return;

    planInput.value = planId;
    if (!this.productForm.contains(planInput)) {
      planInput.setAttribute("form", this.productForm.getAttribute("id"));
    }
  }

  writeProperties() {
    this.clearProperties();
    this.addProperty("Clan", this.clan.value);
    this.addProperty("Members", this.members.map((member) => this.displayName(member)).filter(Boolean).join(", "));
    if (!this.isFamily) this.addProperty("_For me", this.forMe);

    this.members.forEach((member, index) => {
      const label = `_Member ${index + 1}`;
      this.addProperty(`${label} first name`, member.first);
      this.addProperty(`${label} middle name`, member.middle);
      this.addProperty(`${label} last name`, member.last);
      this.addProperty(`${label} date of birth`, member.dob);
      this.addProperty(`${label} email`, member.email);
      this.addProperty(`${label} phone`, member.phone);
      this.addProperty(`${label} clan`, this.clan.value);
    });
  }

  clearProperties() {
    this.productForm.querySelectorAll("[data-membership-property]").forEach((node) => node.remove());
  }

  addProperty(key, value) {
    if (!value) return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${key}]`;
    input.value = value;
    input.dataset.membershipProperty = "true";
    this.productForm.append(input);
  }

  displayName(member) {
    return [member.first, member.middle, member.last].filter(Boolean).join(" ");
  }

  formatDob(value) {
    const [year, month, day] = value.split("-").map(Number);
    if (!year || !month || !day) return value;
    return new Date(year, month - 1, day).toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
  }

  isAdult(value) {
    if (!value) return false;
    const [year, month, day] = value.split("-").map(Number);
    if (!year || !month || !day) return false;
    const today = new Date();
    let age = today.getFullYear() - year;
    const monthDelta = today.getMonth() - (month - 1);
    if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < day)) age -= 1;
    return age >= ADULT_AGE;
  }

  todayIso() {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${now.getFullYear()}-${month}-${day}`;
  }

  fail(field, message) {
    field.setCustomValidity(message);
    field.reportValidity();
  }
}

if (!window.customElements.get("membership-enrollment")) {
  window.customElements.define("membership-enrollment", MembershipEnrollment);
}
